module.exports = __webpack_public_path__ + "static/media/templateRating.ebd172ad.xlsx";